/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import {
    string, arrayOf, shape, object, bool, func,
} from 'prop-types';

// Helpers
import { isEmpty } from '../../utils/object';

// Components
import DesktopOrderNumber from './Sections/DesktopOrderNumber';
import DesktopItemDetail from  './DesktopItemDetail';
import DesktopInfos from './Sections/DesktopInfos';
import DesktopBillingDetail from './DesktopBillingDetail';
import DesktopBillingDetailGuest from './DesktopBillingDetailGuest';

// Selectors
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const DesktopOrderDetails = ({
    uuid, ROSSOrder, isAuthenticatedStatus, handleRedirectToLogin, loginByRedirect, isHDBrand, fetchIsHDOrderEditable,
    isShowingTrackingWidget, isOrderContainsFoodProduct, deliveryImageFlags,
}) => {
    const featureFlags = useSelector(getFeatureFlags);

    const ROSSCSIFailureReason = ROSSOrder?.csiFailureReason || {};
    const ROSSOrderPartialCreditFlag = ROSSOrder?.partialCreditFlag;
    const ROSSOrderReplacementFlag = ROSSOrder?.replacementFlag;
    const ROSSOrderTotal = ROSSOrder?.orderTotal;

    return (
        <div className="width" key={uuid}>
            <DesktopOrderNumber ROSSOrder={ROSSOrder} />
            {!isEmpty(ROSSOrder) && ROSSOrder?.orders?.map((ROSSOrd, index) => (
                <DesktopItemDetail
                    key={ROSSOrd.intOrderNumber}
                    ROSSOrder={ROSSOrd}
                    ROSSOrderNumber={ROSSOrder?.orderID}
                    ROSSModifyOrder={ROSSOrder?.modifyOrder}
                    ROSSOrderPartialCreditFlag={ROSSOrderPartialCreditFlag}
                    ROSSOrderReplacementFlag={ROSSOrderReplacementFlag}
                    ROSSCSIFailureReason={ROSSCSIFailureReason}
                    isMultiItemOrder={ROSSOrder.orders.length > 1}
                    index={index}
                    handleRedirectToLogin={handleRedirectToLogin}
                    loginByRedirect={loginByRedirect}
                    isHDBrand={isHDBrand}
                    fetchIsHDOrderEditable={fetchIsHDOrderEditable}
                    isShowingTrackingWidget={isShowingTrackingWidget}
                    ROSSOrderTotal={ROSSOrderTotal}
                    deliveryImageFlags={deliveryImageFlags}
                    isOrderContainsFoodProduct={isOrderContainsFoodProduct}
                    isLoadedFromTopic={ROSSOrder.loadedFromTopic}
                />
            ))}
            {isAuthenticatedStatus ? (
                <DesktopBillingDetail ROSSOrder={ROSSOrder} />
            ) : (
                <DesktopBillingDetailGuest ROSSOrder={ROSSOrder} />
            )}
            <DesktopInfos ENABLE_MMO={featureFlags['is-account-mmo-enabled']} />
        </div>
    );
};

DesktopOrderDetails.defaultProps = {
    ROSSOrder: {},
    deliveryImageFlags: {},
};

DesktopOrderDetails.propTypes = {
    uuid: string.isRequired,
    deliveryImageFlags: shape({
        desktop: shape({
            preview: bool.isRequired,
            thumbs: bool.isRequired,
        }),
        mobile: shape({
            preview: bool.isRequired,
            thumbs: bool.isRequired,
        }),
    }),
    ROSSOrder: shape({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        orders: arrayOf(shape({
            actualDeliveryDate: string,
            address: string,
            carrier: string,
            courier: string,
            createdDate: string,
            currentLocation: object,
            deliveryDate: string,
            deliveryImageURL: string,
            deliveryMethod: string,
            deliveryNotes: string,
            history: arrayOf(shape({
                codeStatus: string,
                createdDate: string,
                location: object,
                status: string,
                statusDescription: string,
            })),
            intOrderNumber: string,
        })),
        items: arrayOf(shape({
            productBrand: string,
            itemType: string,
            productName: string,
            productSku: string,
        })),
        origin: string,
        recipientFirstName: string,
        recipientLastName: string,
        signatureImageURL: string,
        status: string,
        statusDescription: string,
        trackingNumber: string,
        type: string,
        warningMessage: string,
    }),
    isAuthenticatedStatus: bool.isRequired,
    handleRedirectToLogin: func.isRequired,
    loginByRedirect: func.isRequired,
    isHDBrand: func.isRequired,
    fetchIsHDOrderEditable: func.isRequired,
    isShowingTrackingWidget: func.isRequired,
    isOrderContainsFoodProduct: bool.isRequired,
};

export default DesktopOrderDetails;
